import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../app/hooks";
import { UserRole } from "../../app/userSlice";

export default function Reports() {
	const { role } = useAppSelector((state) => state.user);

	const navigate = useNavigate();

	useEffect(() => {
		switch (role) {
			case UserRole.Writer:
				navigate("/reports/student");
				break;
			case UserRole.Proctor:
				navigate("/reports/course");
				break;
			default:
				navigate("/adminHome");
				break;
		}
	});

	return "";
}
